export default __webpack_public_path__ + "static/media/logo-bmbf.b8a48a47.svg";